
import React, { useEffect, useState } from "react";
import Axios from 'services/BackendApi/BackendApi';
import { Alert, Button } from "react-bootstrap";
import FormElement from "common/components/FormElement/FormElement";
import { searchService } from "services/BackendApi/searchService";
import SearchBarWidget from "modules/search/components/SearchBar/SearchBar";
import { ShareFill } from "react-bootstrap-icons";
import ShareModal from "modules/search/components/ShareModal/ShareModal";
import SearchFilters from "modules/search/components/SearchFilters/SearchFilters";
import FiltersModal from "modules/search/components/FiltersModal/FiltersModal";
import { searchResultDummy } from "modules/search/dummy/searchresult";
import LoadingBox from "modules/search/components/LoadingBox/LoadingBox";
import MessageBox from "modules/search/components/MessageBox/MessageBox";
import styles from './BusquedaSolrView.module.scss'
import Pagination from "modules/search/components/Pagination/Pagination";
import SearchResultItem from "modules/search/components/SearchResultItem/SearchResultItem";
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';
import { BoxArrowDownRight } from "react-bootstrap-icons";

import SpinnerIcon from 'assets/img/loading'
// import GlifosDigitalArchiveViewer from 'modules/catalog/components/GlifosDigitalArchiveViewer/GlifosDigitalArchiveViewer'
import TemporaryFileViewer from "common/components/TemporaryFileViewer/TemporaryFileViewer";
export default function CargaDocumentosFileView(props) {

  const [codigos, setCodigos] = useState([]);
  const [buscar, setBuscar] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [doctypes, setDoctypes] = useState();
  const [identifiers, setIdentifiers] = useState();
  const [id, setId] = useState();
  const bearer = localStorage.getItem("userInfo");
  const token = JSON.parse(bearer).access_token;
  const [selectedItems, setSelectedItems] = useState(() => {
    const savedItems = localStorage.getItem('selectedItems');
    return savedItems ? JSON.parse(savedItems) : {};
  });
  const [valor, setValor] = useState(() => {
    const value = localStorage.getItem('valor');
    return value;
  });

  const [resultados, setResultados] = useState([]);

  const [searchResult, setSearchResult] = useState({
    loading: true,
    error: false,
    result: {},
  });

  useEffect(() => {
    localStorage.setItem('selectedItems', JSON.stringify(selectedItems));
  }, [selectedItems]);

  // useEffect(() => {
  //   localStorage.setItem('valor', JSON.stringify(valor));
  // }, [valor]);

  useEffect(() => {
    if (searchResult.loading) {
      getData();
    }
    // getReceptions();
  }, []);

  async function getData() {
    let res = await searchService(window.location.search);
    console.log(window.location)
    if (res?.success == "true") {
      if (!Array.isArray(res.records?.record)) {
        res.records.record = [res?.records.record];
      }
      setSearchResult({
        loading: false,
        error: false,
        result: {
          result_header: res?.result_header,
          records: res?.records.record,
        },
      });
    }
    let docs = await Axios.GetAllDocTypes({ urlParams: "1" });
    setDoctypes(docs.data)
    let identifiers = await Axios.GetIdentifiers({ urlParams: "1" });
    setIdentifiers(identifiers.data);
  }

  const handleClose = () => setShow(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    submitForm(e.target.elements);
  };

  const submitForm = (elements) => {
    const searchValue = document.getElementById("searchValue");
    const params = Array.from(elements)
      .concat([searchValue]) // Get all elements in the form
      .filter((item) =>
        ["input", "select"].includes(item.tagName.toLowerCase())
      ) // Filter only input and select elements
      .map((input) => ({ name: input.name, value: input.value })) // Format input values in json
      .filter((item) => item.name !== ""); // Remove blank inputs // Remove duplicate

    const paramsResult = params
      .map((param) => `${param.name}=${encodeURIComponent(param.value)}`)
      .join("&");
    window.location.href = `/archive/catalog/search?${paramsResult}`;
  };

  async function getReceptions() {
    const res = await Axios.receptionCodes({ urlParams: "1" });
    console.log(res);
    let aux = res.data.query_result.models_1.queryOneModel_1.result[0]
    let code = aux.code;
    setBuscar(code);
    setCodigos(res.data.query_result.models_1.queryOneModel_1.result)

  }



  //search result view

  return (
  
    <section>
    <div className={styles.title_bar}>
      <h1>Búsqueda</h1>
      <Link to="/user/logout" className={styles.navlink + " nav-link "}>
        <BoxArrowDownRight /> Cerrar Sesión
      </Link>
    </div>

    <div className={styles.content_area}>
    <div className="row ms-md-1 my-0 my-lg-3 p-0">
      <div className="col-3 d-none d-lg-block">
        <div className="bg-white row py-2 sticky-top shadow-sm rounded">
          <div className="col-12 ">
            <form
              action={`/archive/catalog/search`}
              onSubmit={handleSubmit}
              name="searchForm"
            >
              <SearchFilters />
            </form>
          </div>
        </div>
      </div>
      <div className="col-12 col-lg-9">
        <div className="row bg-white mx-lg-1 p-2 shadow-sm rounded">
          <div className="col-12 col-xl-12">
            <form onSubmit={() => { }}>
              <SearchBarWidget setValor={setValor} valor={valor} />
            </form>
          </div>
          {/* <div className="col-3 col-xl-1">
            <button
              className="btn btn-secondary col-12"
              data-bs-toggle="modal"
              data-bs-target={`#shareSearchModal`}
            >
              <span>
                <ShareFill></ShareFill>
              </span>
            </button>
          </div> */}
        </div>
        {/* <FiltersModal /> */}
        {searchResult.loading ? (
          <LoadingBox />
        ) : searchResult.error ? (
          <MessageBox severity="danger">{searchResult.error}</MessageBox>
        ) : searchResult?.result?.result_header?.total_results === "NaN" ||
          searchResult?.result?.result_header?.total_results === "0" ? (
          <div className="row mx-lg-1 mt-3">
            <div className="col-12 mb-2 p-5 bg-white shadow-sm rounded text-center">
              <h5>No se encontraron resultados.</h5>
            </div>
          </div>
        ) : (
          <div>
            <div className="row px-0 px-lg-4 my-4">
              <Pagination result_header={searchResult?.result?.result_header} />
            </div>
            {searchResult.result.records && doctypes && identifiers &&
              Array.isArray(searchResult.result.records) && (
                <div className={styles.grid_container}>
                  {searchResult.result.records?.map((item) => (
                    <>
                      <SearchResultItem
                        setSelectedItems={setSelectedItems}
                        selectedItems={selectedItems}
                        item={item}
                        docs={doctypes}
                        ids={identifiers}
                        key={item.id}
                        searchargs={window.location.search.replace('?&r=/v1/search/query', "")}
                      // searchargs={searchResult?.result?.result_header?.searchargs?.replace('@r=/v1/search/query', "").replace(/@/g,"&")}
                      />
                    </>
                  ))}
                </div>
              )}
             <div className="row px-0 px-lg-4 my-4">
              <Pagination result_header={searchResult?.result?.result_header} />
            </div> 
          </div>
        )}
      </div>
    </div>
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Archivo Unificado</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.columna}>
        <TemporaryFileViewer pdf={id} grantKey={token} />
      </Modal.Body>
    </Modal>

    <ShareModal
      id={`shareSearchModal`}
      url={`${window.location.origin}`}
      quote={`GLIFOS - library: Búsqueda`}
    />
    </div>
  </section>
  ); 
}